export default {
  name: "Declaration of Employer and Attorney/Agent",
  pageInfo: {
    text: "<i>In accordance with Federal regulations, the employer(s) must attest to abide by certain terms, assurances, and obligations as a condition for receiving temporary labor certification from the U.S. Department of Labor. Applications that fail to attach Appendix C will not be certified by the Department.</i>",
    coloring: "grey",
  },
  sections: [
    {
      name: "Document Upload - Appendix C",
      fields: [
        {
          // code: "F.1",
          machine_name: "ef_1_assurance_attached",
          widget: "file_upload",
          name: "Appendix C",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
          label: `NOTE: Employer must be sure to use the most current version of Appendix C, which is <a href="https://www.dol.gov/agencies/eta/foreign-labor/forms" target="_blank">available here.</a></b>
               <br>
               <br>
                Step 1: Download Appendix C PDF<br>
								Step 2: Review and Sign<br>
								Step 3: Upload below<br>
								<br>
								Only .pdf, .doc, .docx, .txt, .xls, .xlsx files under 30 MB can be uploaded.`,
        },
      ],
    },
    {
      name: "Document Upload - Employer and Attorney/Agent Declarations",
      isVisible: {
        when: "b14_emp_type_id",
        is: "Job Contractor - Joint Employer",
      },
      fields: [
        {
          // code: "F.2",
          machine_name: "ef_2_assurance_attached",
          widget: "file_upload",
          name: "Appendix C - Employer-Client",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
          label: `Step 1: Download <a target='_blank' href='https://www.dol.gov/agencies/eta/foreign-labor/forms'>Appendix C</a> PDF<br>
          Step 2: Review and Sign<br>
          Step 3: Upload below<br>
          <br>
          Only .pdf, .doc, .docx, .txt, .xls, .xlsx files under 30 MB can be uploaded.`,
          tooltip:
            "You must upload an additional Appendix C for the employer-client identified in Appendix A, if applicable. Retain a copy of each Appendix C uploaded.",
        },
      ],
    },
  ],
};
